var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowBulkSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#5F11EA"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5486_3326)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5486_3326",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5486_3326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6621 55.9922C25.5642 55.9822 25.4691 55.9627 25.377 55.9365C25.4692 55.9627 25.5651 55.9812 25.6631 55.9912L25.834 56H25.833L25.6621 55.9922ZM42.3291 55.9922V55.9912V55.9922ZM54.5869 55.9443C54.5059 55.9654 54.4232 55.9835 54.3379 55.9922V55.9912C54.4231 55.9825 54.506 55.9654 54.5869 55.9443ZM38.3896 55.7432C38.1776 55.8773 37.9333 55.9655 37.6709 55.9922V55.9912C37.7757 55.9805 37.8774 55.9599 37.9756 55.9307C38.1231 55.8868 38.2623 55.8237 38.3896 55.7432ZM37.5 41.3994C38.1992 41.3996 38.7663 41.9668 38.7666 42.666V54.333C38.7666 54.9858 38.2726 55.5229 37.6387 55.5918L37.5 55.5996H25.834L25.6943 55.5918C25.1404 55.5314 24.6924 55.1132 24.5889 54.5732L24.5732 54.4639L24.5674 54.333V42.666C24.5677 41.9667 25.1346 41.3994 25.834 41.3994H37.5ZM54.167 41.3994C54.8662 41.3996 55.4333 41.9668 55.4336 42.666V54.333C55.4336 54.9856 54.9394 55.5228 54.3057 55.5918L54.167 55.5996H42.501L42.3613 55.5918C41.7733 55.5278 41.3045 55.0606 41.2402 54.4727L41.2334 54.3145V42.666C41.2337 41.9668 41.8008 41.3996 42.5 41.3994H54.167ZM40.8408 42.502C40.8355 42.5559 40.834 42.6107 40.834 42.666V54.333H40.833V42.667C40.833 42.6115 40.8355 42.5561 40.8408 42.502ZM27.1006 43.9326V53.0664H36.2334V43.9326H33.7666V48.4785L31.9229 46.9424L31.667 46.7285L31.4111 46.9424L29.5674 48.4785V43.9326H27.1006ZM43.7666 43.9326V53.0664H52.9004V43.9326H50.4336V48.4785L48.5898 46.9424L48.334 46.7285L48.0771 46.9424L46.2334 48.4785V43.9326H43.7666ZM35.833 52.666H35.834H35.833ZM45.834 44.333V49.332L45.833 49.333L45.834 44.333ZM50.833 49.332V49.333L48.333 47.25L50.833 49.332ZM45.834 24.7334C46.5331 24.7338 47.1005 25.3008 47.1006 26V37.666C47.1006 38.3215 46.6007 38.8616 45.9629 38.9268L45.834 38.9326H34.167L34.0361 38.9268C33.4438 38.8662 32.9712 38.396 32.9072 37.8047L32.9004 37.666V26C32.9005 25.3006 33.4675 24.7334 34.167 24.7334H45.834ZM32.5078 37.8379L32.5088 37.8369L32.5078 37.8379ZM35.4336 27.2666V36.3994H44.5674V27.2666H42.1006V31.8115L40.2568 30.2754L40 30.0625L39.7441 30.2754L37.9004 31.8115V27.2666H35.4336ZM37.5 27.666V27.667L35.834 27.666H37.5ZM44.167 27.666V27.667V27.666ZM32.5625 38.123C32.5745 38.1651 32.5884 38.2064 32.6035 38.2471C32.5884 38.2064 32.5745 38.1651 32.5625 38.123Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5486_3326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowBulkSend);
export default __webpack_public_path__ + "static/media/icon-flow-bulk-send.cecdd7f8ae7fc5ce9de64cd5a438e417.svg";
export { ForwardRef as ReactComponent };